/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summary_Share_UnavailableInputs */

const en_summary_share_unavailable = /** @type {(inputs: Summary_Share_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sharing is unavailable on this device. You can still copy the summary.`)
};

const es_summary_share_unavailable = /** @type {(inputs: Summary_Share_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se puede compartir en este dispositivo. Puedes copiar el resumen.`)
};

/**
* | output |
* | --- |
* | "Sharing is unavailable on this device. You can still copy the summary." |
*
* @param {Summary_Share_UnavailableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const summary_share_unavailable = /** @type {((inputs?: Summary_Share_UnavailableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Share_UnavailableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_summary_share_unavailable(inputs)
	return en_summary_share_unavailable(inputs)
});